import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { setInputData } from "../../Redux/Actions/Application/functions"
import { toggleModal } from "../../Redux/Actions/User/functions"

import { modalUsi } from "../SimpleModal/SimpleModal"

import CheckBox from "../CheckBox"

import "./Transition.css"

const TransitionGoals = () => {
  const dispatch = useDispatch()

  const { goals, options } = useSelector((state) => {
    const isSpouse = window.location.href.includes('spouse')
    const fallbackOptions = [
      { id: 1, text: "Identify who I am as a person" },
      { id: 2, text: "Increase communication about transition with my spouse" },
      { id: 3, text: "Develop a strategy for personal career growth" },
      { id: 4, text: "Share my experiences with others" },
      { id: 5, text: "Understand more about my own purpose" },
      { id: 6, text: "Create goals for my personal purpose work after the military" },
      { id: 7, text: "Meet others that are going through a shared experience" },
      { id: 8, text: "Gain confidence in my personal skills in abilities" },
      { id: 9, text: "Networking opportunities" }
    ]

    if (isSpouse) {
      return {
        goals: state.spouseApplication.application.transition?.goals || "",
        options: fallbackOptions
      }
    }

    const appGoals = state.application.application.transition?.goals || ""
    const inputs = state.formulary?.application?.inputs || {}
    const transitionInput = Object.values(inputs).find(
      ({ section }) => section === "transition"
    )

    return {
      goals: appGoals,
      options: (transitionInput && Array.isArray(transitionInput.options) && transitionInput.options.length)
        ? transitionInput.options
        : fallbackOptions
    }
  })

  const [goalsValues, setGoalsValues] = useState(() => {
    const goalsStr = goals || ""
    return goalsStr.split(";").map(g => g.trim()).filter((goal) => Boolean(goal))
  })

  // Sync goalsValues when goals prop changes from Redux
  useEffect(() => {
    const goalsStr = goals || ""
    const parsedGoals = goalsStr.split(";").map(g => g.trim()).filter((goal) => Boolean(goal))
    setGoalsValues(parsedGoals)
  }, [goals])

  const onOptionClick = (option) => {
    const label = option?.text ?? option?.title ?? option?.value ?? ''
    const trimmedLabel = label.trim()
    const isOptionSelected = goalsValues.some(g => g.trim() === trimmedLabel)
    const newGoalsValues = isOptionSelected
      ? goalsValues.filter((value) => value.trim() !== trimmedLabel)
      : [...goalsValues, trimmedLabel]

    if (newGoalsValues.length > 3) {
      dispatch(
        toggleModal({
          modal_mode: true,
          modal_usi: modalUsi,
          title: "ERROR",
          text: "You can only choose up to three options."
        })
      )
      return
    }

    setGoalsValues(newGoalsValues)

    /* Doing this to keep backwards compatibility with legacy implementation */
    dispatch(
      setInputData([
        {
          userField: "transition.goals",
          value: newGoalsValues.join(";"),
          required: true
        }
      ])
    )
  }

  return (
    <div className="transition-goals-container">
      {options.map((option, idx) => {
        const label = option?.text ?? option?.title ?? option?.value ?? ''
        const trimmedLabel = label.trim()
        const isChecked = goalsValues.some(g => g.trim() === trimmedLabel)
        return (
          <CheckBox
            key={option.id}
            id={option.id.toString()}
            text={label}
            checked={isChecked}
            onClick={() => onOptionClick({ ...option, text: label })}
            className="checkBox"
          />
        )
      })}
    </div>
  )
}

export default TransitionGoals
